'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    infinite: {
      type: Boolean,
      default: false
    },
    sliderIndex: {
      type: [Number, String],
      default: 0
    },
    scrollable: {
      //设置是否可以通过滑动手势来切换页面，默认为 true
      type: Boolean,
      default: true
    },
    sliderStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasMargin: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    sliderChange: function sliderChange(index) {
      // this.sliderIndex = index
      this.$emit('dofPanelSlider', index);
    }
  },
  watch: {
    sliderIndex: function sliderIndex(newVal) {
      if (this.sliderIndex !== newVal) {
        this.sliderIndex = newVal;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-tab-page-container/index.vue
// module id = 404
// module chunks = 0 1